export const ASK_DEMO: string = "ASK_DEMO";
export const ASK_DEMO_SUCCESS: string = "ASK_DEMO_SUCCESS";
export const ASK_DEMO_FAIL: string = "ASK_DEMO_FAIL";
export const RESET_ASK_DEMO: string = "ASK_DEMO_FAIL";

export const RESEND_DEMO: string = "RESEND_DEMO";
export const RESEND_DEMO_SUCCESS: string = "RESEND_DEMO_SUCCESS";
export const RESEND_DEMO_FAIL: string = "RESEND_DEMO_FAIL";
